/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AccountAuthorisationPanel } from 'web-ui-components/lib/finance/accounts';
import { ProminentLabel } from 'web-ui-components/lib/typography/labels';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import withContent from '../../../containers/withContent';
import chapsSubmittedContent, { contentPropTypes } from './chapsSubmitted.content';
import { getBatchAuthorisationType, getBatchAuthorisers, isBatchTypeUpload } from '../../../states/batch/selectors';
import { isUserPaymentAuthoriser, getAuthorisationMessage } from '../../../helpers/fieldHelpers';
import { getUserId } from '../../../states/user/selectors';
import ApiConstants from '../../../config/apiConstants';

const mapState = (state) => ({
	batchAuthType: getBatchAuthorisationType(state),
	userId: getUserId(state),
	authorisers: getBatchAuthorisers(state),
	isBatchTypeUpload: isBatchTypeUpload(state),
});

const ChapsSubmittedAuthorisePanel = ({
	content,
	authorisers,
	userId,
	batchAuthType,
	handleRoute,
	isBatchTypeUpload,
}) => {
	const getAuthPanelMessage = () => {
		if (!isUserPaymentAuthoriser(authorisers, userId) || authorisers.length > 1) {
			return getAuthorisationMessage(authorisers, userId);
		}
		if (batchAuthType === ApiConstants.hardToken) return content.batchAuthorisationHardToken;
		return content.batchAuthorisationSoftToken;
	};

	const {
		fileUploadTwoStepInstructionHeading,
		fileUploadFirstInstruction,
		fileUploadSecondInstruction,
		fileUploadThirdInstruction,
		fileUploadFourthInstruction,
		fileUploadFifthInstruction,
		fileUploadReviewButton,
	} = content;
	if (isBatchTypeUpload && batchAuthType === ApiConstants.softToken) {
		return (
			<AccountAuthorisationPanel titleText={fileUploadTwoStepInstructionHeading}>
				<center>
					<p>{fileUploadFirstInstruction}</p>
					<ProminentLabel>{fileUploadSecondInstruction}</ProminentLabel>
					<p>{fileUploadThirdInstruction}</p>
					<ProminentLabel>{fileUploadFourthInstruction}</ProminentLabel>
					<p>{fileUploadFifthInstruction}</p>
					{isUserPaymentAuthoriser(authorisers, userId) && (
						<ActionButton.Primary
							labelText={fileUploadReviewButton}
							onClick={() => handleRoute('WEB-MANAGE-PAYMENT-STATUS')}
						/>
					)}
				</center>
			</AccountAuthorisationPanel>
		);
	}
	return (
		<AccountAuthorisationPanel>
			<center>
				<p>{getAuthPanelMessage()}</p>
			</center>
			{batchAuthType === ApiConstants.hardToken && (
				<div style={{ textAlign: 'center' }}>
					<NavigationButton.Primary
						labelText={content.authoriseButtonText}
						onClick={() => handleRoute('WEB-MANAGE-PAYMENT-STATUS')}
					/>
				</div>
			)}
		</AccountAuthorisationPanel>
	);
};

ChapsSubmittedAuthorisePanel.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	authorisers: PropTypes.arrayOf(PropTypes.shape({})),
	userId: PropTypes.string,
	batchAuthType: PropTypes.string,
	handleRoute: PropTypes.func,
	isBatchTypeUpload: PropTypes.bool,
};

const contentWrapper = withContent({ content: chapsSubmittedContent });
export default connect(mapState)(contentWrapper(ChapsSubmittedAuthorisePanel));
export const ConnectWrapper = connect(mapState)(ChapsSubmittedAuthorisePanel);
